// Product-description videos (.pv-video + .pv-sound). Replaces the player that used to be pasted into
// each description as an inline <script>. Wraps that still carry their own <script> are left alone.
// data-pv-fit="1" on the wrap = size the frame to the video's real ratio (what some pasted copies did).
// ponytail: one behaviour for all; the WaterWipes copies had a gesture-gated audio start on phones - add back if missed.
(function () {
  var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  // Sound on without a tap: iPhone Safari either refuses play() OR plays a split second and then PAUSES the video itself
  // (the 2026-10-20 bug: video left frozen + silent, so the first-tap unmute had nothing playing to unmute).
  // Either way: keep it playing muted; the shopper's first touch turns the sound on.
  function soundTry(v) {
    var t = Date.now();
    var back = function () { v.removeEventListener('pause', onPause); };
    var onPause = function () { back(); if (Date.now() - t < 1500 && !document.hidden && inView(v)) { v.muted = true; v.play().catch(function () {}); } };
    v.addEventListener('pause', onPause); setTimeout(back, 1500);
    v.muted = false;
    return v.play().catch(function () { back(); v.muted = true; return v.play().catch(function () {}); });
  }
  function init(video) {
    var wrap = video.closest('.product-video-wrap') || video.parentElement;
    if (!wrap || wrap.dataset.pvInit || wrap.querySelector('script')) return;
    wrap.dataset.pvInit = '1';
    var btn = wrap.querySelector('.pv-sound');
    var iconMuted = btn && btn.querySelector('.pv-icon-muted');
    var iconUnmuted = btn && btn.querySelector('.pv-icon-unmuted');
    var tried = false;
    function sync() {
      if (!iconMuted || !iconUnmuted) return;
      iconMuted.style.display = video.muted ? 'block' : 'none';
      iconUnmuted.style.display = video.muted ? 'none' : 'block';
    }
    function start() {
      if (tried) return Promise.resolve();
      tried = true;
      // sound first everywhere (Hamza 2026-10-11); if the browser refuses, it plays muted and the shopper's first tap
      // on the page turns the sound on (soundOnFirstTap below)
      return soundTry(video).then(sync);
    }
    if (wrap.dataset.pvFit) {
      video.addEventListener('loadedmetadata', function () {
        if (video.videoWidth && video.videoHeight) wrap.style.aspectRatio = video.videoWidth + ' / ' + video.videoHeight;
        // landscape video in a frame capped for portrait (420px) ends up tiny -> full width of its column (matches the product grid)
        if (video.videoWidth > video.videoHeight) wrap.style.maxWidth = '100%';
      }, { once: true });
    }
    if (btn) {
      btn.style.display = 'flex';
      sync();
      btn.addEventListener('click', function (e) { e.preventDefault(); video.muted = !video.muted; video.play().catch(function () {}); sync(); });
    }
    // tap/click on the video = sound on/off (like reels); scrolling away still pauses it
    video.addEventListener('click', function () { video.muted = !video.muted; video.play().catch(function () {}); sync(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var en = entries[0];
        if (!en) return;
        // play once a quarter shows, pause only when almost gone (<10%): short banners at the top of Baby & Kids / Dyson
        // were paused (and on iPhone stopped loading) by a small scroll under the old 60% rule (Hamza 2026-10-16)
        if (en.intersectionRatio >= 0.25) start().then(function () { if (video.paused) video.play().catch(function () {}); });
        else if (en.intersectionRatio < 0.1) video.pause();
      }, { threshold: [0, 0.1, 0.25] }).observe(wrap);
    } else start();
  }
  // Banner/description videos start invisible (base.css) over their poster frame and only appear once they are really
  // playing. When a phone blocks autoplay (iPhone Low Power Mode) Safari draws its own big ▶ inside the video that no
  // CSS can hide — an invisible video hides it too. Tapping the frame still starts the video.
  function cover(video) {
    var wrap = video.closest('.product-video-wrap') || video.parentElement;
    if (!wrap || wrap.dataset.pvCover) return;
    wrap.dataset.pvCover = '1';
    wrap.classList.add('pv-js');
    var src = video.getAttribute('poster');
    var on = function () { video.classList.add('pv-on'); };
    if (src && !/your-thumbnail/.test(src)) {
      wrap.style.setProperty('--pv-poster', 'url("' + src + '")');
      wrap.classList.add('pv-covered');
    } else {
      // no poster (videos pasted into descriptions): paint the video's first frame onto a canvas behind it instead
      var cv = document.createElement('canvas');
      cv.className = 'pv-frame';
      cv.setAttribute('aria-hidden', 'true');
      video.before(cv);
      var paint = function () {
        if (!video.videoWidth) return;
        cv.width = video.videoWidth; cv.height = video.videoHeight;
        try { cv.getContext('2d').drawImage(video, 0, 0, cv.width, cv.height); } catch (e) {}
      };
      video.addEventListener('loadeddata', paint, { once: true });
      if (video.readyState >= 2) paint();
      if (video.preload !== 'auto') { video.preload = 'auto'; try { video.load(); } catch (e) {} }
    }
    var check = function () { if (!video.paused && video.currentTime > 0) on(); };
    video.addEventListener('playing', check);
    video.addEventListener('timeupdate', check);
    check();
    video.addEventListener('click', function () { if (video.paused) { video.muted = true; video.play().catch(function () {}); } });
  }
  // Browsers only allow sound after the shopper has tapped/clicked on the page. On product, collection and page (Lifestyle, Baby & Kids…) pages the first
  // tap anywhere turns the sound on for the video that is playing on screen (the speaker button still mutes it).
  if (/\/(products|collections|pages)\//.test(location.pathname)) {
    var armed = true, soundOn = false, userOff = false;   // soundOn: the shopper has had sound; userOff: they muted it themselves (Hamza 2026-10-19)
    var unmute = function (e) {
      if (!armed) return;
      // tapping the video or its speaker button toggles sound by itself — leave that tap alone
      // (not the whole frame: a scroll that starts on a banner — e.g. the registry video's link layer — must still count)
      // ...but only where tapping the video toggles sound itself (videos run by this file). Banners with their own
      // player (Baby & Kids, registry) don't, and on phones the registry video fills the screen, so the first scroll
      // usually starts on it — that touch must turn the sound on.
      var t = e && e.target && e.target.closest ? e.target : null;
      if (t && t.closest('.pv-sound')) { armed = false; return; }
      var tw = t && t.closest('.product-video-wrap');
      if (tw && tw.dataset.pvInit) { armed = false; return; }
      document.querySelectorAll('video.pv-video').forEach(function (v) {
        var r = v.getBoundingClientRect();
        var onScreen = r.bottom > 0 && r.top < innerHeight && r.height > 0;
        if (!v.paused && v.muted && onScreen && !v.dataset.pvUserMuted) {
          var w = v.closest('.product-video-wrap') || v.parentElement;
          var m = w.querySelector('.pv-icon-muted'), u = w.querySelector('.pv-icon-unmuted');
          // some touches (a scroll on iPhone) don't count as a tap: Safari refuses, or plays a split second and then stops the
          // video. soundTry puts it back playing muted; only call it a success if it still has sound 1.6 s later.
          // Scroll / touch-start retries: max 2 per video (each refused try = a blip of sound) - real taps (click) always try (2026-10-20)
          if (!e || (e.type !== 'click' && e.type !== 'keydown')) { var n = +(v.dataset.pvTries || 0); if (n >= 2) return; v.dataset.pvTries = n + 1; }
          soundTry(v).then(function () {
            setTimeout(function () { if (!v.muted && !v.paused) { armed = false; soundOn = true; if (m && u) { m.style.display = 'none'; u.style.display = 'block'; } } }, 1600);
          });
        }
      });
    };
    ['pointerdown', 'keydown', 'touchend', 'click'].forEach(function (ev) { document.addEventListener(ev, unmute, { capture: true }); });
    // iPhone: a scroll gesture only "counts" once it has happened, so also retry while the page scrolls (at most ~1x/second).
    // Needed when a banner fills the phone screen and every first touch lands on it (registry video).
    var lastTry = 0;
    window.addEventListener('scroll', function () { var n = Date.now(); if (armed && n - lastTry > 900) { lastTry = n; unmute(null); } }, { passive: true });
    // a tap on the speaker button itself is the shopper's own choice — don't fight it
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.pv-sound');
      if (b) { armed = false; var v = (b.closest('.product-video-wrap') || b.parentElement).querySelector('video'); if (v) { v.dataset.pvUserMuted = v.muted ? '1' : ''; userOff = v.muted; if (!v.muted) soundOn = true; } }
    }, true);
    // the next video down the page: if the shopper had sound (and didn't mute it), it starts with sound too; if the phone
    // refuses, it plays muted and the next touch/scroll turns it on (the 'first touch' rule re-arms for it)
    document.addEventListener('playing', function (e) {
      var v = e.target;
      if (!v || v.tagName !== 'VIDEO' || !v.classList.contains('pv-video')) return;
      if (!v.muted) { setTimeout(function () { if (!v.muted && !v.paused) soundOn = true; }, 1600); return; }   // a video that got (and kept) sound by itself also counts
      if (!soundOn || userOff || !v.muted || v.dataset.pvUserMuted || v.dataset.pvSoundTried) return;
      v.dataset.pvSoundTried = '1';                      // ONE try per video: a refused try restarts it muted, which fires 'playing' again (iPhone loop = flicker)
      armed = true;
      soundTry(v).then(function () { if (!v.muted && !v.paused) armed = false; });
    }, true);
    // counts only if the sound is still on 1.6 s later (a refused iPhone try un-mutes for a split second, then stops)
    document.addEventListener('volumechange', function (e) { var v = e.target; if (v && v.tagName === 'VIDEO' && v.classList.contains('pv-video') && !v.muted && !v.paused) setTimeout(function () { if (!v.muted && !v.paused) soundOn = true; }, 1600); }, true);
  }

  // switching to another tab/app pauses every video (sound included); coming back resumes them.
  // Phone lock (iPhone pauses the video itself before 'hidden' fires) + sound being refused on return used to leave it paused:
  // on return, any video that is on screen plays again; if sound is refused it plays muted (speaker button still works).
  var resume = [];
  function inView(v) { var r = v.getBoundingClientRect(); if (!r.height) return false; var h = Math.min(r.bottom, innerHeight) - Math.max(r.top, 0); return h / r.height >= 0.25; }
  // every <video> on the page: ones that were playing resume; auto-playing ones (our banners/descriptions, autoplay or looped) that are on screen restart
  function auto(v) { return v.classList.contains('pv-video') || v.autoplay || v.loop; }
  function wake() {
    document.querySelectorAll('video').forEach(function (v) {
      if (v.paused && (resume.indexOf(v) >= 0 || (auto(v) && inView(v))))
        v.play().catch(function () { v.muted = true; v.play().catch(function () {}); });
    });
    resume = [];
  }
  // while search/menu is open or the app is in the background, nothing may start playing (the scroll watcher above and the
  // gift card / registry videos used to restart a video behind the open search: Hamza 2026-10-24 "not pausing video when search is open")
  var hold = false;
  document.addEventListener('play', function (e) {
    var v = e.target; if (!hold || !v || v.tagName !== 'VIDEO') return;
    v.pause(); if (resume.indexOf(v) < 0) resume.push(v);
  }, true);
  document.addEventListener('visibilitychange', function () {
    hold = document.hidden;
    if (document.hidden) {
      resume = [];
      document.querySelectorAll('video').forEach(function (v) { if (!v.paused) { resume.push(v); v.pause(); } });
    } else setTimeout(wake, 150);
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) setTimeout(wake, 150); });   // back/forward cache restore
  // opening search or the menu pauses every page video (banners AND product videos); closing plays them again (Hamza 2026-10-16, menu 2026-10-20)
  document.addEventListener('toggle', function (e) {
    var d = e.target; if (!d || !d.closest) return;
    var isMenu = d.id === 'Details-menu-drawer-container';   // the drawer itself, not its sub-menus
    if (!isMenu && !(d.closest('.header__search, details-modal') && d.querySelector('predictive-search, input[type="search"]'))) return;
    if (d.open) { hold = true; resume = []; document.querySelectorAll('video').forEach(function (v) { if (!v.paused) { resume.push(v); v.pause(); } }); }
    else { hold = false; setTimeout(wake, 150); }
  }, true);
  function scan() { document.querySelectorAll('video.pv-video').forEach(function (v) { init(v); cover(v); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
})();
